import { createStyles, WithStyles, withStyles } from '@material-ui/core/styles';
import 'moment/locale/it';
import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { IState } from '../../redux/store';
import { Card, CircularProgress, Divider } from '@material-ui/core';
import CustomersIcon from '@material-ui/icons/GroupOutlined';
import DomainsIcon from '@material-ui/icons/Domain';
import MonetizationOnOutlinedIcon from '@material-ui/icons/MonetizationOnOutlined';
import VarPartnerLevel from '../../components/Vars/VarPartnerLevel';
import { PERMISSIONS } from '../../services/PermissionService/PermissionConstants';
import { IVarOpportunityInDTO } from '../../repository/jago/model/input/IVarOpportunityInDTO';
import { getVarActiveBadges, getVarPartnerLevel, isDemoCustomer } from '../../utils/Utils';
import AbilityProvider from '../../services/PermissionService/AbilityProvider';
import { IVarInDTO } from '../../repository/jago/model/input/IVarInDTO';
import { PaginatedDataDTO } from '@bottega52/commons-pagination';
import { ICustomerInDTO } from '../../repository/jago/model/input/ICustomerInDTO';
import * as CreditsActions from '../../redux/credits/credits.actions';
import * as VarsActions from '../../redux/vars/vars.actions';
import * as ModalsActions from '../../redux/modals/modals.actions';
import { GREEN_MAIN } from '../../style/StyleConsts';
import _ from 'lodash';
import moment from 'moment';
import ReduxLanguage from '../../components/ReduxLanguage';
import { IDomainInDTO } from '../../repository/jago/model/input/IDomainInDTO';
import { VarOpportunityStatusOptions } from '../../codec/varOpportunityInDTODecoder';
import { ModalTypes } from '../../components/Modals/ModalTypes';
import { IVarBurnRateInDTO } from '../../repository/jago/model/input/IVarBurnRateInDTO';
import FireIconCustom from '../../components/Icons/FireIconCustom';

const styles = createStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: 0,
  },
  header: {
    backgroundColor: 'white',
    width: '100%',
    zIndex: 200,
    padding: 10,
    paddingRight: 20,
    borderBottom: '2px solid #5AC0B1',
  },
  cardsContainer: {
    display: 'flex',
    gap: 60,
    padding: '0 20px',
  },
  statCard: {
    flex: 1,
    padding: 20,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  statTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: '#666',
    marginBottom: 10,
  },
  statNumber: {
    fontSize: 24,
    fontWeight: 'bold',
    color: GREEN_MAIN,
  }
});

type IReduxProps = ConnectedProps<typeof connector>;

export interface IServiceStatusProps extends WithStyles<typeof styles> {

}

export type ComponentProps = IServiceStatusProps & IReduxProps;

export interface IServiceStatusPageState {
  isLoading: boolean;
};

class ServiceStatus extends React.Component<ComponentProps,IServiceStatusPageState> {

  constructor(props: ComponentProps) {
    super(props);

    this.state = {
      isLoading: false,
    };
  }

  public async componentDidMount() {
    const { dispatch, VAR } = this.props;
    if (!VAR || !(VAR as IVarInDTO).id)
      this.setState({ isLoading: true });
    try {
      const resultVAR = await dispatch<any>(VarsActions.fetchVar());
      // TODO le altre fetch che servono per le 4 cards sotto
      const promises = []
      if (AbilityProvider.getAbilityHelper().hasPermission(PERMISSIONS.CUSTOMER_READ))
        promises.push(dispatch<any>(CreditsActions.fetchCustomers({ page: 0, pageSize: 1000 })));
      if (AbilityProvider.getAbilityHelper().hasPermission(PERMISSIONS.OPPORTUNITY_READ))
        promises.push(dispatch<any>(VarsActions.fetchOpportunities({ page: 0, pageSize: 1000 })));
      if (AbilityProvider.getAbilityHelper().hasPermission(PERMISSIONS.DOMAIN_READ))
        promises.push(dispatch<any>(CreditsActions.fetchCustomerWalletPlants({ page: 0, pageSize: 1000, walletId: undefined }, true)));
      promises.push(dispatch<any>(VarsActions.fetchVarBurnRate((resultVAR as IVarInDTO).id)));
      if (promises.length > 0)
        await Promise.all(promises);
      this.setState({ isLoading: false });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  }

  public onOpenVarCertificate() {
    const { dispatch, VAR } = this.props;
    const varData = (VAR as IVarInDTO);
    const varLevel = getVarPartnerLevel(varData);
    dispatch<any>(ModalsActions.showModal(`OPERATIONAL_VAR_CERTIFICATE`, {
      modalType: ModalTypes.CONTENT_MODAL,
      modalProps: {
        content: (
          <iframe
            title="Var certificate"
            width="100%"
            height="100%"
            frameBorder="0"
            id="serviceFrameSend"
            style={{ objectPosition: 'center'}}
            src={`/varCertificateGenerator/generate_certificate.html?iseo_entity=${varData.company}&var_name=${varData.name}&var_address=${varData.address}&cert_number=${moment().format('YYYY-MM')}&cert_date=${moment(varData.lastTrainingDate).format('LL')}&val_level=${varLevel}`}
          />

        ),
        title: 'VAR Certificate',
        onCancel: () => dispatch<any>(ModalsActions.hideModal(`OPERATIONAL_VAR_CERTIFICATE`)),
        fullScreen: true,
        titleMessageKey: 'forms.varFormTitle',
      }
    }));
  }

  private canDownloadCertificate(varData: IVarInDTO, currentVarLevel: number) {
    return varData && 
      varData.lastTrainingDate && 
      varData.lastTrainingDateExpirationDate && !moment(varData.lastTrainingDateExpirationDate).startOf('day').isBefore(moment().startOf('day')) && 
      AbilityProvider.getAbilityHelper().hasPermission(PERMISSIONS.VAR_DOWNLOAD_CERTIFICATE) && 
      currentVarLevel >= 1;
  }

  render() {
    const { classes, VAR, varBurnRate, customers, opportunities, domains, whatsNewContent } = this.props;
    const { isLoading } = this.state;
    const varData = (VAR as IVarInDTO);
    const activeBadgesIndexes = getVarActiveBadges(varData);
    const currentVarLevel = _.size(activeBadgesIndexes);
    
    const runningQuotationsStatuses = [VarOpportunityStatusOptions.DRAFT, VarOpportunityStatusOptions.ON_APPROVAL, VarOpportunityStatusOptions.APPROVED];
    const runningQuotationsCounter = (
      (opportunities as PaginatedDataDTO<IVarOpportunityInDTO>).content || []
    ).filter(opportunity => runningQuotationsStatuses.includes(opportunity.status as VarOpportunityStatusOptions)).length;
    
    const customersData = (customers as PaginatedDataDTO<ICustomerInDTO>).content || [];
    const activeCustomersCounter = customersData
      .filter(customer => !isDemoCustomer(customer.name))
      .length;
    
    const activeSystemsCounter = ((domains as PaginatedDataDTO<IDomainInDTO>).content || []).length;
    const monthlyCreditsBurnRate = varBurnRate ? _.ceil(((varBurnRate as IVarBurnRateInDTO).burnRate / 100) * 30) || "-" : "-";

    const showDownloadCertificateButton = this.canDownloadCertificate(varData, currentVarLevel);

    return (
      <div className={classes.container}>
        <Card style={{ marginTop: 20, marginLeft: 20, marginRight: 20, marginBottom: 20, minHeight: 148 }}>
          {isLoading ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 148 }}>
              <CircularProgress style={{ color: GREEN_MAIN }} />
            </div>
          ) : (
            <VarPartnerLevel activeBadgesIndexes={activeBadgesIndexes} onOpenVarCertificate={showDownloadCertificateButton ? () => {this.onOpenVarCertificate()} : undefined}/>
          )}
        </Card>
        {isLoading ? null : (
          <div className={classes.cardsContainer}>
            <Card className={classes.statCard}>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <h4 className={classes.statTitle} style={{ color: '#3f3f3f' }}><ReduxLanguage languageKey='vars.runningQuotations' /></h4>
                <MonetizationOnOutlinedIcon style={{ fontSize: 22, color: '#3f3f3f', marginLeft: 5 }} />
              </div>
              <div className={classes.statNumber}>{runningQuotationsCounter}</div>
            </Card>
            <Card className={classes.statCard}>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <h4 className={classes.statTitle} style={{ color: '#3f3f3f' }}><ReduxLanguage languageKey='vars.activeCustomers' /></h4>
                <CustomersIcon style={{ fontSize: 22, color: '#3f3f3f', marginLeft: 5, marginBottom: 1 }} />
              </div>
              <div className={classes.statNumber}>{activeCustomersCounter}</div>
            </Card>
            <Card className={classes.statCard}>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <h4 className={classes.statTitle} style={{ color: '#3f3f3f' }}><ReduxLanguage languageKey='vars.activeSystems' /></h4>
                <DomainsIcon style={{ fontSize: 22, color: '#3f3f3f', marginLeft: 5, marginBottom: 2 }} />
              </div>
              <div className={classes.statNumber}>{activeSystemsCounter}</div>
            </Card>
            <Card className={classes.statCard}>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <h4 className={classes.statTitle} style={{ color: '#3f3f3f' }}><ReduxLanguage languageKey='vars.monthlyCreditsBurnRate' /></h4>
                <FireIconCustom style={{ width: 25, color: '#3f3f3f', marginLeft: 5, marginBottom: 2 }} />
              </div>
              <div className={classes.statNumber}>{monthlyCreditsBurnRate}</div>
            </Card>
          </div>
        )}
        <Card style={{ marginTop: 20, marginLeft: 20, marginRight: 20, marginBottom: 20 }}>
          <div style={{fontSize: 18, fontWeight: 600, color: '#888', marginBottom: 8, letterSpacing: 1, width: 'max-content', backgroundColor: '#eee', 
            padding: 6, marginTop: '24px', paddingLeft: '24px'}}>
            {'WHAT\'S NEW'}
          </div>
          {!whatsNewContent || !whatsNewContent.length ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 148 }}>
              <CircularProgress style={{ color: GREEN_MAIN }} />
            </div>
          ) : (
            <div style={{display: 'flex', flexDirection: 'row', gap: 10, background: '#fff', borderRadius: 4, 
              padding: 20, paddingTop: 10, paddingBottom: 10, overflowX: 'auto'}}>
              {_.map(whatsNewContent, article => (
                <>
                  {article && article.preview ? (

                    <Card className="hover-container" style={{ paddingBottom: 60, minWidth: 500, display: 'flex', flexDirection: 'column' }} onClick={() => window.open(article.link)}>
                      <div style={{ padding: 20, paddingBottom: 0, paddingLeft: 14, }}>
                      {article && article.previewImage ? <img alt="preview" style={{ minHeight: 50, width: '45%', marginBottom: 10, display: 'flex' }} src={article.previewImage} /> : null}
                        <h3 style={{ margin: 0, fontWeight: 'bold', color: '#3f3f3f', marginBottom: 5, fontSize: 15 }}>{article.renderedTitle ? article.renderedTitle : article.title}</h3>
                        {article.date ? <h4 style={{ margin: 0}}>{moment(article.date).format('LL')}</h4> : null}
                      </div>
                      <div className="storeContentContainer" style={{ padding: 25, paddingLeft: 15, paddingTop: 0, marginBottom: 0 }} dangerouslySetInnerHTML={{ __html: article.preview }} />
                      <span style={{flexGrow: 1}}></span>
                    </Card>
                  ): null}
                  <Divider style={{ zIndex: 100 }} />
                </>
              ))}
            </div>
          )}
          
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state: IState) {
  return {
    VAR: state.vars.VAR.data,
    varBurnRate: state.vars.varBurnRate.data,
    customers: state.credits.customers.data,
    opportunities: state.vars.opportunities.data,
    domains: state.credits.domains.data,
    whatsNewContent: state.settings.whatsNew.content,
  };
}

const connector = connect(mapStateToProps);

export default connector(withStyles(styles)(ServiceStatus as any));